import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import MenuSection from "@/components/MenuSection";

export default function MenuPage() {
  return (
    <div className="min-h-screen pt-16" data-testid="menu-page">
      <header className="max-w-7xl mx-auto px-6 pt-10 pb-8 border-b-2 border-zinc-800 flex flex-wrap items-end justify-between gap-6">
        <div>
          <a
            href="/"
            className="inline-flex items-center gap-2 border-2 border-zinc-700 bg-white hover:border-ember px-6 py-3.5 font-mono font-bold text-sm tracking-wide uppercase text-ink hover:text-ember transition-colors duration-300 mb-6"
            data-testid="menu-back-home"
          >
            <ArrowLeft className="w-5 h-5" /> Back to home
          </a>
          <h1 className="font-display text-6xl sm:text-7xl leading-none uppercase text-gold-shine" data-testid="menu-page-heading">
            Our Menu
          </h1>
          <p className="mt-3 font-mono text-sm tracking-[0.15em] uppercase text-zinc-500 max-w-xl" data-testid="menu-page-note">
            This page is for browsing — to order, tap Order Now and build your order on the order page
          </p>
        </div>
        <Link
          to="/order"
          data-testid="menu-order-button"
          className="inline-flex items-center gap-3 bg-ember hover:bg-ember-hover text-white font-bold px-10 py-5 text-base tracking-wide uppercase transition-colors duration-300 ember-glow"
        >
          Order Now <ArrowRight className="w-5 h-5" />
        </Link>
      </header>
      <MenuSection standalone />
    </div>
  );
}
